import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SpeciesNzorNameService {
  constructor(private http: HttpClient) {}

  getSpeciesNZORName(speciesId: number) {
    return this.http.get('/rest/species/nzor/' + speciesId);
  }
}
